<div *ngIf="layout === 'row'"
     class="_input-rounded _px-0 _max-w-90% md:_max-w-100% _mx-auto">
    <form [formGroup]="formGroup">
        <div class="_w-full">
            {{ activeFilter }}
            <div class="_flex _items-center _justify-center _gap-1 _relative _flex-1">
                <ng-container *ngIf="availabilityType && includeComingSoon !== undefined">
       
                    <ng-container *feature="'res-638-ai-search-or-simple-text-autocompletion-for-countrycity'">
                        <ng-container *ngIf="aiSearchEnabled">
                            <app-search-ai 
                                [initWithValue]="aiSearchInitWithValue"
                                (onSearchInput)="aiSearch($event)"
                                (onSearchActivated)="toggleAiSearch($event)">
                            </app-search-ai>

                            <div class="_h-6 _w-nudge-1 _bg-primary-1-tint-10"></div>
                        </ng-container>
                    </ng-container>

                    <app-search-criteria-where-to-menu
                        [border]="false"
                        formControlName="whereTo"
                        [includeComingSoon]="includeComingSoon"
                        [availabilityType]="availabilityType"
                        (forceSearch)="search()"
                        (activeRegionChanged)="onActiveRegionChange($event)"
                        (searchRegionNameChanged)="searchRegionName.next($event)">
                    </app-search-criteria-where-to-menu>

                    <div class="_h-6 _w-nudge-1 _bg-primary-1-tint-10"></div>

                    <app-datepicker
                        [border]="false"
                        [travelDates]="travelDates"
                        (newDateSearch)="newSearchDates($event)">
                    </app-datepicker>

                    <div class="_h-6 _w-nudge-1 _bg-primary-1-tint-10"></div>

                    <app-search-criteria-guests
                        [border]="false"
                        [guestsRestrictions$]="guestRestrictions$"
                        formControlName="guests"
                        showTotalGuests="true">
                    </app-search-criteria-guests>

                    <div class="_h-6 _w-nudge-1 _bg-primary-1-tint-10"></div>

                    <app-search-text (locationSelectedEvent)="onLocationSelected($event)"></app-search-text>

                </ng-container>
            </div>
        </div>

        <div class="_flex">
            <ng-content></ng-content>
        </div>
    </form>
</div>

<div *ngIf="layout === 'col'">
    <form [formGroup]="formGroup">
        <div class="_flex _flex-col _gap-4">
            <app-search-criteria-where-to-menu
                    [inline]="true"
                    [activateMenuPanel]="activeFilter === 'region'"
                    formControlName="whereTo"
                    [includeComingSoon]="includeComingSoon"
                    [availabilityType]="availabilityType"
                    (forceSearch)="search()"
                    (activeRegionChanged)="onActiveRegionChange($event)"
                    (searchRegionNameChanged)="searchRegionName.next($event)"
                    class="_w-full">
            </app-search-criteria-where-to-menu>

            <app-datepicker
                    [inline]="true"
                    [activateCalendar]="activeFilter === 'date'"
                    [travelDates]="travelDates"
                    (newDateSearch)="newSearchDates($event)">
            </app-datepicker>

            <app-search-criteria-guests
                    [inline]="true"
                    [activateChooseGuests]="activeFilter === 'guests'"
                    [showTotalGuests]="false"
                    [guestsRestrictions$]="guestRestrictions$"
                    formControlName="guests"
                    class="_pb-2">
            </app-search-criteria-guests>
        </div>
    </form>
</div>
